import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraTag } from '../ensigns/tag';
import { SpecraText } from '../ensigns/typography';
/** Document/file identity with category, metadata, and product-owned actions. */ export function SpecraFileRow({ actions, category, className, icon, meta, name, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex min-w-0 flex-wrap items-center gap-3 py-2.5', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraIconTile, {
                children: icon ?? '↗'
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate font-medium",
                        size: "caption",
                        children: name
                    }),
                    meta ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        size: "micro",
                        tone: "muted",
                        children: meta
                    }) : null
                ]
            }),
            category ? /*#__PURE__*/ _jsx(SpecraTag, {
                children: category
            }) : null,
            actions ? /*#__PURE__*/ _jsx("div", {
                className: "ml-auto flex flex-wrap items-center gap-1",
                children: actions
            }) : null
        ]
    });
}
